import api from '@/services/api'

const BASE_URL = '/one-page'

export default class StrategyService {
    constructor() {
        this.api = api
    }
    get_onepage_all() {
        return this.api
            .get(`${BASE_URL}/company/first`)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    get_onepage_search(id, params) {
        return this.api
            .get(`${BASE_URL}/${id}?${params}`)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    get_sections_all() {
        return this.api
            .get(`/sections?search=unit&searchFields=type`)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    put_onepage_all(id, body) {
        return this.api
            .put(`${BASE_URL}/${id}`, body)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    put_unity(id, body) {
        return this.api
            .put(`${BASE_URL}/${id}/sync-business-unit`, body)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    put_block(id, body) {
        return this.api
            .put(`${BASE_URL}/${id}/sync-block`, body)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    get_attributes(id, params) {
        if (params === undefined) {
            return this.api
                .get(`${BASE_URL}/block/attribute/${id}/all`)
                .then(({ data }) => {
                    return data
                })
                .catch((err) => console.log(err))
        } else {
            return this.api
                .get(`${BASE_URL}/block/attribute/${id}/all?${params}`)
                .then(({ data }) => {
                    return data
                })
                .catch((err) => console.log(err))
        }
    }
    getAttributeId(id, params) {
        return this.api
            .get(`${BASE_URL}/block/attribute/${id}?${params}`)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    post_attribute(body) {
        return new Promise((res, rej) => {
            this.api
                .post(`${BASE_URL}/block/attribute`, body)
                .then(({ data }) => {
                    res(data)
                    return data
                })
                .catch((err) => {
                    console.log(err)
                    rej(false)
                })
        })
    }
    put_attribute(id, body) {
        return new Promise((res, rej) => {
            this.api
                .put(`${BASE_URL}/block/attribute/${id}`, body)
                .then(({ data }) => {
                    res(data)
                    return data
                })
                .catch((err) => {
                    rej(false)
                    console.log(err)
                })
        })
    }
    put_attribute_horizon(id, body) {
        return this.api
            .put(`${BASE_URL}/block/attribute/${id}/sync-horizon`, body)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    delete_attribute(id) {
        return this.api
            .delete(`${BASE_URL}/block/attribute/${id}`)
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    getOnePageHorizons(onePageId) {
        return this.api
            .get(`${BASE_URL}/${onePageId}/horizons`, {
                params: {
                    with: 'horizon',
                },
            })
            .then(({ data }) => {
                return data
            })
            .catch((err) => console.log(err))
    }
    updateHorizons(onePageId, horizons) {
        return this.api.put(`${BASE_URL}/${onePageId}/update-horizons`, horizons)
    }
    getObjectivesWithoutAttribute(attributeId, page = 1, perPage = 10) {
        return this.api
            .get('/objectives', {
                params: {
                    withoutAttribute: attributeId,
                    page,
                    per_page: perPage,
                    with: 'user;key_results;key_results.user;key_results.last_checkin;period',
                    scopes: 'notArchived',
                },
            })
            .then((resp) => {
                return resp.data.data
            })
            .catch((err) => console.log(err))
    }
    getObjectivesByAttribute(attributeId, page = 1, perPage = 10) {
        return this.api
            .get(`/one-page/block/attribute/${attributeId}`, {
                params: {
                    page,
                    objectives_per_page: perPage,
                    with: 'objectives;objectives.user;objectives.period;objectives.key_results;objectives.key_results.user;objectives.key_results.last_checkin',
                },
            })
            .then((resp) => {
                return resp.data.data.objectives
            })
            .catch((err) => console.log(err))
    }
    updateLinkedObjectives(attributeId, objectivesToLinkIDs) {
        return this.api
            .put(`${BASE_URL}/block/attribute/${attributeId}/link-objectives`, {
                objective_ids: objectivesToLinkIDs,
            })
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                console.log(err)
            })
    }
}
